import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { getAuth } from "firebase/auth";
import { app } from "../../../app/config/firebase";
import { useSelector } from "react-redux";
import Page from "../../../app/common/components/Page";
import { Container, Grid, Menu } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { HOME_PAGE_ROUTE } from "../../../app/api/routeConstants";
import VerifyEmailHandler from "./VerifyEmailHandler";
import logo from "../../../assets/icons/logo-white.svg";
import { NAVBAR_STYLES } from "../../../css/styles";
import Footer from "../../footer/Footer";
import PasswordResetHandler from "./PasswordResetHandler";
import useRedirectAuth from "../../../app/hooks/useRedirectAuth";

const VERIFY_EMAIL_MODE = "verifyEmail";
const RESET_PASSWORD_MODE = "resetPassword";

export default function AuthHandlerPage() {
  const auth = getAuth(app);
  const history = useHistory();

  const parsed = queryString.parse(window.location.search);
  const mode = parsed.mode;
  const actionCode = parsed.oobCode;

  const { currentUserAccount } = useSelector((state) => state.account);
  const { responsive } = useSelector((state) => state.app);

  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    if (!mode || ![VERIFY_EMAIL_MODE, RESET_PASSWORD_MODE].includes(mode)) {
      history.push(HOME_PAGE_ROUTE);
    }
  }, [history, mode]);

  useEffect(() => {
    if (mode === RESET_PASSWORD_MODE) return;
    if (!currentUserAccount) {
      setIsVerified(false);
    } else {
      setIsVerified(currentUserAccount?.isEmailVerified);
    }
  }, [currentUserAccount, history, mode]);

  useRedirectAuth({
    shouldExecute: isVerified,
  });

  function handleReloadClick() {
    history.push(HOME_PAGE_ROUTE);
    window.location.reload();
  }

  return (
    <Page title="Authentication | Hello Radius">
      <Menu
        className="navbar-menu"
        text
        fixed="top"
        style={NAVBAR_STYLES.navbar}
      >
        <Container>
          <Menu.Item
            disabled={!isVerified && mode === VERIFY_EMAIL_MODE}
            onClick={handleReloadClick}
          >
            <div className="hello-radius-logo-container">
              <img
                className="hello-radius-logo"
                src={logo}
                alt="hello radius"
                data-testid="hello-radius-logo-image-testid"
              />
            </div>
          </Menu.Item>
        </Container>
      </Menu>
      <div className="overlay-page">
        <Grid container textAlign="center" centered>
          <Grid.Column
            computer={mode === VERIFY_EMAIL_MODE ? 8 : 7}
            tablet={13}
            mobile={13}
          >
            <div style={{ marginTop: responsive.isMobile ? 40 : 100 }}>
              {mode === VERIFY_EMAIL_MODE && (
                <VerifyEmailHandler
                  auth={auth}
                  actionCode={actionCode}
                  isVerified={isVerified}
                />
              )}
              {mode === RESET_PASSWORD_MODE && (
                <PasswordResetHandler auth={auth} actionCode={actionCode} />
              )}
            </div>
          </Grid.Column>
        </Grid>
      </div>
      <Footer isShowLinks={isVerified || mode === RESET_PASSWORD_MODE} />
    </Page>
  );
}
